import catalog from "../data/employersCatalog.json";

export function getEmployers() {
  return catalog.employers || [];
}

export function getAccountsForEmployer(employerId) {
  if (!employerId) return [];
  return catalog.accountsByEmployer[employerId] || [];
}

export function getEmployerById(employerId) {
  return getEmployers().find((e) => e.id === employerId);
}

export function getAccountByIds(employerId, accountId) {
  return getAccountsForEmployer(employerId).find((a) => a.id === accountId);
}
